import { useEffect, useState } from "react"
import { getConfigurationsTestsByCompanyId } from "../../../../features/search/service/config-tests"
import { getMe } from "../../../../features/search/service/user-service"
import { User } from "../../../../shared/types/user"
import { MenuTop } from "../../../../components/menu/top/menu-top"
import { useNavigate } from "react-router-dom"
import "./styles/list.css"
import ButtonComponent from "../../../../components/button/button"

interface ConfigTest {
    id: string | number
    firstValue: string
    secondValue: string
    currency: string
    languageId: string
    companyId: string | number
    language?: {
        name: string
        code: string
    }
    createdAt?: string
}

export const AdminListConfigs = () => {
    const navigate = useNavigate()
    const [configs, setConfigs] = useState<ConfigTest[]>([])
    const [me, setMe] = useState<User | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe()
                setMe(userData)
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error)
                setError('Não foi possível carregar os dados do usuário')
            }
        }
        fetchUser()
    }, [])

    useEffect(() => {
        if (!me?.company?.id) return

        const fetchConfigs = async () => {
            try {
                setLoading(true)
                setError(null)

                const configsData = await getConfigurationsTestsByCompanyId(me?.company?.id!)
                setConfigs(configsData || [])
            } catch (error) {
                console.error('❌ Erro ao buscar configurações:', error)
                setError('Não foi possível carregar as configurações')
            } finally {
                setLoading(false)
            }
        }

        fetchConfigs()
    }, [me])

    const handleAddNew = () => {
        navigate('/admin-painel/add-configs')
    }

    const handleEdit = (configId: string | number) => {
        navigate(`/admin-painel/configs/edit/${configId}`)
    }

    if (loading) {
        return (
            <div className="admin-configs-page">
                <MenuTop />
                <div className="configs-loading">
                    <div className="configs-loading-text">Carregando configurações...</div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="admin-configs-page">
                <MenuTop />
                <div className="configs-error">
                    <div className="configs-error-text">{error}</div>
                </div>
            </div>
        )
    }

    return (
        <div className="admin-configs-page">
            <MenuTop />
            <div className="configs-container">
                {/* Header */}
                <div className="configs-header">
                    <div className="configs-header-content">
                        <div>
                            <h1 className="configs-title">Configurações de Testes</h1>
                            <p className="configs-subtitle">
                                {configs.length} {configs.length === 1 ? 'configuração' : 'configurações'} cadastrada{configs.length !== 1 && 's'}
                            </p>
                        </div>

                        {/* <ButtonComponent
                            label="Adicionar Configuração"
                            onClick={handleAddNew}
                        /> */}
                    </div>
                </div>

                {/* Lista de configurações */}
                <div className="configs-grid">
                    {configs.map((config) => (
                        <div key={config.id} className="config-card">
                            {/* Valores */}
                            <div className="config-values">
                                <div className="config-value-item">
                                    <span className="config-value-label">Valor Atrasado:</span>
                                    <span className="config-value-amount">
                                        {config.currency} {config.firstValue}
                                    </span>
                                </div>
                                <div className="config-value-item">
                                    <span className="config-value-label">Valor Adiantado:</span>
                                    <span className="config-value-amount">
                                        {config.currency} {config.secondValue}
                                    </span>
                                </div>
                            </div>

                            {/* Detalhes */}
                            <div className="config-details">
                                <div className="config-detail-row">
                                    <span className="config-detail-label">Moeda:</span>
                                    <span className="config-detail-value">{config.currency}</span>
                                </div>
                                {config.language && (
                                    <div className="config-detail-row">
                                        <span className="config-detail-label">Idioma:</span>
                                        <span className="config-detail-value">
                                            {config.language.name || config.language.code}
                                        </span>
                                    </div>
                                )}
                                {config.createdAt && (
                                    <div className="config-detail-row">
                                        <span className="config-detail-label">Criado em:</span>
                                        <span className="config-detail-value">
                                            {new Date(config.createdAt).toLocaleDateString('pt-BR')}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Ações */}
                            <div className="config-card-footer">
                                <button 
                                    className="config-action-button config-edit-button"
                                    onClick={() => handleEdit(config.id)}
                                >
                                    Editar
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Empty state */}
                {configs.length === 0 && (
                    <div className="configs-empty">
                        <div className="configs-empty-icon">⚙️</div>
                        <div className="configs-empty-text">
                            Nenhuma configuração encontrada
                        </div>
                        <button className="configs-empty-button" onClick={handleAddNew}>
                            + Criar primeira configuração
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}